export const setLocalStorageData = (name: string, value: any) => {
  return localStorage.setItem(name, JSON.stringify(value));
};

export const getData = (name: string) => {
  const storedData = localStorage.getItem(name);
  const data = storedData && JSON.parse(storedData);
  return data;
};

export const clearStorage = () => {
  localStorage.clear();
};

export const removeLocalStorageData = (name: string) => {
  localStorage.removeItem(name);
};

export const getUserToken = () => {
  const user = getData("persist:persist-key");
  const auth = JSON.parse(user?.auth || "{}");
  return auth?.accessToken;
};
